import { orderBy, uniqueId } from 'lodash-es';

import { checkEmpty } from 'core/services/utils';

export const REQUIRED_MSG = 'This is required';

// General utility functions

export const toCapitalizeOrUpper = (str) => {
  if (checkEmpty(str)) {
    return '';
  }

  const frags = str.split(' ');
  return frags
    .map((frag) => {
      if (
        [
          'csv',
          'ioc',
          'ip',
          'mac',
          'taxii',
          'url',
          'id',
          'api',
          'dns',
          'http',
          'ssh',
          'ssl',
          'dhcp',
          'ftp',
          'irc',
          'ntlm',
          'radius',
          'rdp',
          'rfb',
          'sip',
          'smb',
          'smtp',
          'snmp',
          'socks',
          'tls',
        ].indexOf(frag) >= 0
      ) {
        return frag.toUpperCase();
      } else if (frag === 'dcerpc') {
        return 'DCE/RPC';
      } else {
        return frag.charAt(0).toUpperCase() + frag.slice(1).toLowerCase();
      }
    })
    .join(' ');
};

export const sortBy = (rows, sortByFields, sortDirections) => {
  if (!sortByFields || sortByFields.length === 0) {
    return rows;
  }

  return orderBy(
    rows,
    Array.isArray(sortByFields) ? sortByFields : [sortByFields],
    Array.isArray(sortDirections) ? sortDirections : [sortDirections]
  );
};

export const nameComparator = (a, b) => a.name.localeCompare(b.name);

export const getUniqueId = (prefix?: string) => uniqueId(prefix || 'JASK_UI_');
